/**
 * @generated SignedSource<<9a8a5e23d1f2b7a3ef4b1b9d5a73baf2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UserActionLastActionQuery$variables = {
  action?: ReadonlyArray<string> | null | undefined;
  id: string;
};
export type UserActionLastActionQuery$data = {
  readonly allUserActions: {
    readonly nodes: ReadonlyArray<{
      readonly actionType: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly timeStamp: any;
    }> | null | undefined;
  } | null | undefined;
};
export type UserActionLastActionQuery = {
  response: UserActionLastActionQuery$data;
  variables: UserActionLastActionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "action"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "actionTypeId",
            "variableName": "action"
          },
          {
            "kind": "Variable",
            "name": "userId",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "filter"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      },
      {
        "kind": "Literal",
        "name": "order",
        "value": [
          {
            "timeStamp": "DESC"
          }
        ]
      }
    ],
    "concreteType": "UserActionNodeConnection",
    "kind": "LinkedField",
    "name": "allUserActions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserActionNode",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeStamp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ActionTypeNode",
            "kind": "LinkedField",
            "name": "actionType",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserActionLastActionQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserActionLastActionQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "30b52a887d01ae90984adb1640eb38f0",
    "id": null,
    "metadata": {},
    "name": "UserActionLastActionQuery",
    "operationKind": "query",
    "text": "query UserActionLastActionQuery(\n  $id: ID!\n  $action: [ID!]\n) {\n  allUserActions(first: 1, filter: {userId: $id, actionTypeId: $action}, order: [{timeStamp: DESC}]) {\n    nodes {\n      id\n      timeStamp\n      actionType {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "08dc67313ceed81c209ad66a9da9d6fb";

export default node;
